import { defineStore } from 'pinia'
import { IdentityData } from '~concierge/types/IdentityTypes'
import { ConciergeEventData, ConciergeIdentityData } from '~types/concierge-event'

export const useIdentityStore = defineStore('identity', {
  state: () => ({
    identity: <IdentityData | ConciergeIdentityData | null>null,
    event: <ConciergeEventData | null>null
  }),
  actions: {
    setIdentity(identityData: IdentityData) {
      this.identity = identityData
    },
    setEventIdentity(eventIdentityData: ConciergeIdentityData) {
      this.identity = eventIdentityData
    },
    setEvent(eventData: ConciergeEventData) {
      this.event = eventData
    },
    clearIdentity() {
      this.identity = null
    },
    clearEvent() {
      this.event = null
    }
  }
})
